import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, CheckCircle2, FileText, Lock, RotateCcw } from 'lucide-react';
import { API, api, czDate } from '../../utils/deliveryApi';

// Last screen: what is still missing (same check as the server), PDF preview, close / reopen
const SummaryStep = ({ protocol, user, onGo, reload }) => {
  const [problems, setProblems] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const closed = protocol.status === 'closed';
  const issues = Object.values(protocol.items || {}).filter((i) => i.issue).length;

  useEffect(() => {
    if (closed) return;
    api(`/${protocol.id}/validation`).then((d) => setProblems(d.problems)).catch((e) => setError(e.message));
  }, [protocol, closed]);

  const close = async () => {
    if (!window.confirm('Uzavřít protokol? PDF se uloží k trenažéru i do dokumentů zákazníka a trenažér se označí jako Doručený.')) return;
    setBusy(true); setError('');
    try { await api(`/${protocol.id}/close`, { method: 'POST' }); await reload(); } catch (e) {
      setError(e.message);
      if (e.data?.problems) setProblems(e.data.problems);
    } finally { setBusy(false); }
  };
  const reopen = async () => {
    if (!window.confirm('Znovu otevřít uzavřený protokol? Změna se zapíše do historie.')) return;
    setBusy(true); setError('');
    try { await api(`/${protocol.id}/reopen`, { method: 'POST' }); await reload(); } catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  return (
    <section className="dlv-card" aria-labelledby="dlv-summary">
      <div className="dlv-section-head">
        <span className="dlv-section-head__num">✓</span>
        <h2 id="dlv-summary" className="dlv-section-head__title">{closed ? 'Protokol uzavřen' : 'Shrnutí a uzavření'}</h2>
      </div>

      {closed ? (
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', margin: '10px 0 18px' }}>
          <CheckCircle2 size={28} color="#2e7d32" />
          <p style={{ margin: 0 }}>
            Uzavřeno {new Date(protocol.closed_at).toLocaleString('cs-CZ')}{protocol.closed_by_name ? ` (${protocol.closed_by_name})` : ''}.
            PDF je uložené v dokumentech trenažéru i zákazníka, trenažér je ve stavu <strong>Doručeno</strong> s datem předání {czDate(protocol.steps?.[5]?.checked_date)}.
          </p>
        </div>
      ) : problems === null ? <p className="dlv-hint">Kontroluji úplnost…</p> : problems.length === 0 ? (
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', margin: '10px 0 18px' }}>
          <CheckCircle2 size={28} color="#2e7d32" />
          <p style={{ margin: 0 }}>Vše je vyplněné{issues ? ` (výhrady: ${issues})` : ''}. Protokol můžete uzavřít.</p>
        </div>
      ) : (
        <div style={{ margin: '10px 0 18px' }}>
          <p className="dlv-hint">Před uzavřením zbývá doplnit ({problems.length}) – klepnutím přejdete na krok:</p>
          {problems.slice(0, 30).map((p, i) => (
            <button key={i} type="button" className="dlv-problem" onClick={() => onGo(p.step)}>
              <AlertTriangle size={16} /> <strong>{p.step === 0 ? 'Údaje' : `Krok ${String(p.step).padStart(2, '0')}`}</strong> {p.message}
            </button>
          ))}
        </div>
      )}

      {error && <p role="alert" style={{ color: '#b71c1c' }}>{error}</p>}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        <a className="dlv-btn" href={`${API}/${protocol.id}/pdf`} target="_blank" rel="noreferrer"><FileText size={18} /> {closed ? 'Otevřít PDF' : 'Náhled PDF'}</a>
        {protocol.customer_id && <Link className="dlv-btn" to={`/customers/${protocol.customer_id}`}>Detail zákazníka</Link>}
        <Link className="dlv-btn" to={`/machines/${protocol.machine_id}`}>Detail trenažéru</Link>
        {!closed && <button type="button" className="dlv-btn dlv-btn--primary" disabled={busy || !problems || problems.length > 0} onClick={close}><Lock size={18} /> Uzavřít a připojit ke klientovi</button>}
        {closed && user?.role === 'admin' && <button type="button" className="dlv-btn" disabled={busy} onClick={reopen}><RotateCcw size={18} /> Znovu otevřít</button>}
      </div>
    </section>
  );
};

export default SummaryStep;
